// biome-ignore lint/performance/noBarrelFile: re-export
export { default as memoize } from "lodash/memoize";
